import { type FC } from 'react'

import { useDeviceDetectorContext } from '../../../../../../device-detector'
import { useGlobalConfigContext } from '../../../../../../global-config'
import { TENANT } from '../../../../../../tenant'
import { ProductPrescriptionDrawer } from '../../../../ProductPrescriptionDrawer/ProductPrescriptionDrawer'
import { type ProductPrescriptionDrawerControls } from '../../../../ProductPrescriptionDrawer/useProductPrescriptionDrawerControls'
import { ProductPagePrescriptionTypeSelectionModal } from '../../ProductPagePrescriptionTypeSelectionModal/ProductPagePrescriptionTypeSelectionModal'
import { ProductPagePrescriptionTypeSelectionModalDesktop } from '../../ProductPagePrescriptionTypeSelectionModalDesktop/ProductPagePrescriptionTypeSelectionModalDesktop'

type ProductAddToCartPrescriptionRedemptionProps = {
  controls: ProductPrescriptionDrawerControls
}

/** Selects the tenant- and device-specific prescription-redemption interface. */
export const ProductAddToCartPrescriptionRedemption: FC<
  ProductAddToCartPrescriptionRedemptionProps
> = ({ controls }) => {
  const { isMobile } = useDeviceDetectorContext()
  const globalConfig = useGlobalConfigContext()

  if (globalConfig.tenant === TENANT.COM) {
    return <ProductPrescriptionDrawer controls={controls} />
  }

  if (isMobile) {
    return <ProductPagePrescriptionTypeSelectionModal controls={controls} />
  }

  return (
    <ProductPagePrescriptionTypeSelectionModalDesktop controls={controls} />
  )
}
